import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import { Loader, Breadcrumbs } from 'kangarootime-ui';
import EventsCalendar from './Calendar';
import EventPopup from './EventPopup';
import actions from './duck/actions';
import moment from 'moment';
import RaisedContainer from '../../components/RaisedContainer';

class Events extends Component {
  constructor (props) {
    super(props);

    this.state = {
      visibleMonthDate: moment(),
      selectedEvent: null,
      newEventStartDate: moment(),
      newEventEndDate: moment(),
      showEventPopup: false
    };
  }

  get breadcrumbs () {
    return [
      { label: 'Events', link: null }
    ];
  }

  get eventsForVisibleMonth () {
    const { eventsByMonth } = this.props;
    const { visibleMonthDate } = this.state;
    const monthYearKey = visibleMonthDate.format('YYYY-MM');

    if (eventsByMonth[monthYearKey]) {
      return [eventsByMonth[monthYearKey].events, eventsByMonth[monthYearKey].birthdays];
    }

    return [[], []];
  }

  componentDidMount = () => {
    this.fetchEvents();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.visibleMonthDate !== this.state.visibleMonthDate) {
      this.fetchEvents();
    }

    if (prevProps.creatingEvent && !this.props.creatingEvent) {
      this.dismissEventPopup();
    }
  }

  handleMonthChange = newDate => {
    const { visibleMonthDate } = this.state;
    const m = moment(newDate);
    const newMonthDate = visibleMonthDate.clone().month(m.month()).year(m.year());

    this.setState({ visibleMonthDate: newMonthDate });
  }

  handleEventSelect = event => {
    // don't do anything if a birthday is selected
    if (event.type === 'birthday') {
      return;
    }

    this.setState({ showEventPopup: true, selectedEvent: event });
  }

  handleDateSelect = slot => {
    const { start, end } = slot;

    // ignore any clcks on dates before today
    if (moment(start).isSameOrAfter(moment(), 'date')) {
      this.setState({
        showEventPopup: true,
        newEventStartDate: moment(start),
        newEventEndDate: moment(end)
      });
    }
  }

  fetchEvents = () => {
    const { visibleMonthDate } = this.state;

    const startOfMonth = visibleMonthDate.clone().startOf('month');
    const endOfMonth = visibleMonthDate.clone().endOf('month');

    this.props.getEvents(startOfMonth, endOfMonth);
  }

  dismissEventPopup = () => this.setState({ showEventPopup: false, selectedEvent: null, newEventStartDate: moment() });

  render () {
    const [monthEvents, monthBirthdays] = this.eventsForVisibleMonth;

    return (
      <NavigationBars>
        <Loader loading={false}>
          <div className='flex-columns flex-1'>
            <Breadcrumbs breadcrumbs={this.breadcrumbs} />
            <RaisedContainer style={{ height: '80vh' }}>
              <EventsCalendar
                events={monthEvents}
                fetchingEvents={this.props.fetchingEvents}
                birthdays={monthBirthdays}
                onMonthChange={this.handleMonthChange}
                onEventSelect={this.handleEventSelect}
                onDateSelect={this.handleDateSelect}
              />
            </RaisedContainer>
          </div>
          { this.state.showEventPopup &&
            <EventPopup
              isOpen={this.state.showEventPopup}
              onClose={this.dismissEventPopup}
              event={this.state.selectedEvent}
              newEventStartDate={this.state.newEventStartDate}
              newEventEndDate={this.state.newEventEndDate}
              onSave={this.props.saveEvent}
              creatingEvent={this.props.creatingEvent}
            />
          }
        </Loader>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    eventsByMonth: state.events.byMonth,
    fetchingEvents: state.events.meta.fetchingEvents,
    creatingEvent: state.events.meta.creatingEvent
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getEvents: (startOfMonth, endOfMonth) => dispatch(actions.getEventsRequest(startOfMonth, endOfMonth)),
    saveEvent: (
      id,
      title,
      location,
      date,
      startTime,
      endTime,
      description,
      isAllDay
    ) => dispatch(actions.saveEventRequest(
      id,
      title,
      location,
      date,
      startTime,
      endTime,
      description,
      isAllDay
    ))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Events);
